module.exports = __webpack_public_path__ + "public/media/step_4_guess_party_confetti.low.5525e7dc.mp4";